import React from 'react';
import { Box, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';
import { formatTime } from './helpers';

/**
 * Where an editor says how its work stands: unsaved while there are edits in
 * hand, and what time they were saved once there are not.
 *
 * The saved line carries no icon. The warning is asking for something and marks
 * itself accordingly; this is only an answer, and stands until the next edit
 * takes its place or the page is left.
 *
 * Props:
 *   isDirty   (bool)        - Whether the page is holding unsaved work.
 *   savedAt   (Date|string) - Optional; when the page last saved. Only read
 *                             while there is nothing unsaved.
 *   className (string)      - The class the page places this with.
 */
function UnsavedChangesWarning({ isDirty, savedAt, className }) {
  if (isDirty) {
    return (
      <Box className={`unsavedWarning ${className ?? ''}`}>
        <FontAwesomeIcon icon={faTriangleExclamation} className="unsavedWarningIcon" />
        <Typography className="unsavedWarningText">Changes not yet saved.</Typography>
      </Box>
    );
  }

  const savedTime = formatTime(savedAt);
  if (!savedTime) return null;

  return (
    <Box className={`unsavedWarning ${className ?? ''}`}>
      <Typography className="unsavedWarningText">Changes saved at {savedTime}</Typography>
    </Box>
  );
}

export default UnsavedChangesWarning;
